import type { PluginRouteFactory } from "@d12labs/plugins/types";
import { createRoute } from "@tanstack/react-router";
import { lazy } from "react";

const ChatPage = lazy(() => import("./pages/chat.page").then((m) => ({ default: m.ChatPage })));

export const createPluginRoutes: PluginRouteFactory = (parentRoute) => [
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/ai-chat",
		component: ChatPage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/ai-chat/$id",
		component: ChatPage,
	}),
];
